export interface SettlementFines {
  date: string;
  reason: string;
  order: string;
  amount: string;
}

export interface Settlement {
  id: number;
  period: string;
  dateRange: string;
  orders: number;
  sales: string;
  commissionRate: number;
  commission: string;
  fines: string;
  net: string;
  status: "review" | "transferred" | "pending" | "partial";
  statusLabel: string;
  finesList: SettlementFines[];
  bank: {
    name: string;
    iban: string;
    date: string;
    ref: string;
  } | null;
  disputes: { order: string; amount: string; status: string }[];
}

export const settlements: Settlement[] = [
  {
    id: 1,
    period: "1-15 أغسطس",
    dateRange: "1 أغسطس - 15 أغسطس 2026",
    orders: 50,
    sales: "5,000",
    commissionRate: 15,
    commission: "750",
    fines: "50",
    net: "4,200",
    status: "review",
    statusLabel: "قيد المراجعة",
    finesList: [
      { date: "9 أغسطس", reason: "تأخير في الوصول", order: "#GH-2820", amount: "50" },
    ],
    bank: null,
    disputes: [
      { order: "#GH-2860", amount: "150", status: "نزاع مفتوح" },
    ],
  },
  {
    id: 2,
    period: "16-31 يوليو",
    dateRange: "16 يوليو - 31 يوليو 2026",
    orders: 43,
    sales: "4,200",
    commissionRate: 15,
    commission: "630",
    fines: "0",
    net: "3,570",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "3 أغسطس 2026",
      ref: "REF-88412",
    },
    disputes: [],
  },
  {
    id: 3,
    period: "1-15 يوليو",
    dateRange: "1 يوليو - 15 يوليو 2026",
    orders: 38,
    sales: "3,800",
    commissionRate: 15,
    commission: "570",
    fines: "100",
    net: "3,130",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [
      { date: "12 يوليو", reason: "إلغاء متكرر", order: "#GH-2710", amount: "100" },
    ],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "19 يوليو 2026",
      ref: "REF-85671",
    },
    disputes: [],
  },
  {
    id: 4,
    period: "16-30 يونيو",
    dateRange: "16 يونيو - 30 يونيو 2026",
    orders: 52,
    sales: "5,100",
    commissionRate: 15,
    commission: "765",
    fines: "0",
    net: "4,335",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "5 يوليو 2026",
      ref: "REF-84120",
    },
    disputes: [],
  },
  {
    id: 5,
    period: "1-15 يونيو",
    dateRange: "1 يونيو - 15 يونيو 2026",
    orders: 41,
    sales: "4,050",
    commissionRate: 15,
    commission: "607",
    fines: "30",
    net: "3,413",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [
      { date: "7 يونيو", reason: "غياب عن موعد", order: "#GH-2599", amount: "30" },
    ],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "20 يونيو 2026",
      ref: "REF-82833",
    },
    disputes: [],
  },
  {
    id: 6,
    period: "16-31 مايو",
    dateRange: "16 مايو - 31 مايو 2026",
    orders: 36,
    sales: "3,600",
    commissionRate: 15,
    commission: "540",
    fines: "0",
    net: "3,060",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "4 يونيو 2026",
      ref: "REF-81505",
    },
    disputes: [],
  },
  {
    id: 7,
    period: "1-15 مايو",
    dateRange: "1 مايو - 15 مايو 2026",
    orders: 44,
    sales: "4,350",
    commissionRate: 15,
    commission: "652",
    fines: "0",
    net: "3,698",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    finesList: [],
    bank: {
      name: "مصرف الراجحي",
      iban: "SA44 2000 0001 2345 6789 1234",
      date: "21 مايو 2026",
      ref: "REF-80219",
    },
    disputes: [],
  },
];